"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsRow = void 0;
var Utilities_1 = require("../../Utilities");
var DetailsRow_base_1 = require("./DetailsRow.base");
var DetailsRow_styles_1 = require("./DetailsRow.styles");
exports.DetailsRow = Utilities_1.styled(DetailsRow_base_1.DetailsRowBase, DetailsRow_styles_1.getDetailsRowStyles, undefined, {
    scope: 'DetailsRow',
});
//# sourceMappingURL=DetailsRow.js.map